var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login"},[_c('div',{staticClass:"container text-center"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('h1',[_vm._v("Click below to use your GoPass credentials.")]),_c('router-link',{staticClass:"gy-btn btn",attrs:{"to":"/signin"}},[_vm._v("Log In")])],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }